// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2P5io","containerItemsCenter":"Skeleton_containerItemsCenter__1cUQf"};